var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRocket({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 39.07,
    height: 70,
    viewBox: "0 0 39.07 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "ivory"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.462,
    stopColor: "#f9f9ef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ebebeb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fa8800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e31926"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fa8800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7b97e2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7b1ae2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fb3780"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8338ec"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons8-launch",
    transform: "translate(-12 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4047",
    "data-name": "Path 4047",
    d: "M30.185,35a8.185,8.185,0,1,0,8.185,8.185A8.185,8.185,0,0,0,30.185,35Z",
    transform: "translate(6.214 20.63)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4048",
    "data-name": "Path 4048",
    d: "M43.01,36.637a5.729,5.729,0,1,0,5.729,5.729A5.729,5.729,0,0,0,43.01,36.637ZM24.185,35a8.185,8.185,0,1,0,8.185,8.185A8.185,8.185,0,0,0,24.185,35Z",
    transform: "translate(2.331 20.63)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4049",
    "data-name": "Path 4049",
    d: "M17.729,36a5.729,5.729,0,1,0,5.729,5.729A5.729,5.729,0,0,0,17.729,36Z",
    transform: "translate(0 21.267)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4050",
    "data-name": "Path 4050",
    d: "M20,37.548a6.548,6.548,0,1,1,13.1,0c0,3.616-6.548,11.459-6.548,11.459S20,41.164,20,37.548Z",
    transform: "translate(4.987 18.083)",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4051",
    "data-name": "Path 4051",
    d: "M22,36.274a3.274,3.274,0,0,1,6.548,0c0,1.807-3.274,4.911-3.274,4.911S22,38.081,22,36.274Z",
    transform: "translate(6.261 19.428)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4052",
    "data-name": "Path 4052",
    d: "M18,17.457v31.1H37.426v-31.1c0-2.588-2.694-7.438-5.245-11.455H23.247C20.7,10.021,18,14.871,18,17.457Z",
    transform: "translate(3.822 2.549)",
    fill: "url(#linear-gradient-6)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2691",
    "data-name": "Group 2691",
    transform: "translate(13.637 2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4053",
    "data-name": "Path 4053",
    d: "M48.8,51.109,40.66,47.838V28.195L48.8,39.65Zm-35.8,0,8.135-3.271V28.195L13,39.65ZM26.409,8.548h8.98C33.085,4.94,30.9,2,30.9,2S28.711,4.94,26.409,8.548ZM40.66,51.109l-3.254,3.274H24.39l-3.254-3.274Z",
    transform: "translate(-13 -2)",
    fill: "url(#linear-gradient-7)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2692",
    "data-name": "Group 2692",
    transform: "translate(28.261 18.229)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4054",
    "data-name": "Path 4054",
    d: "M25.274,12a3.274,3.274,0,1,0,3.274,3.274A3.274,3.274,0,0,0,25.274,12Zm0,9.819a3.274,3.274,0,1,0,3.274,3.274A3.274,3.274,0,0,0,25.274,21.821Zm0,9.822a3.274,3.274,0,1,0,3.274,3.274A3.274,3.274,0,0,0,25.274,31.642Z",
    transform: "translate(-22 -12.002)",
    fill: "url(#linear-gradient)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocket);
export default __webpack_public_path__ + "static/media/rocket.d49e73dcba5d3828c307a5e68e04660f.svg";
export { ForwardRef as ReactComponent };